import { LoyaltyProgramsInt } from "@interfaces/";

export class LoyaltyPrograms {
    static loyaltyProgram: LoyaltyProgramsModel[] = [];
    static findByid(id: string): LoyaltyProgramsModel {
        if(this.getloyaltyProgram().length === 0){
            return new LoyaltyProgramsModel();
        }
      return  this.getloyaltyProgram().find(
            (res: LoyaltyProgramsModel) =>  {
                return res.id === id
            })!;


    }
    static findByName(name: string): LoyaltyProgramsModel {
        if(this.getloyaltyProgram().length === 0){
            return new LoyaltyProgramsModel();
        }
        const found: LoyaltyProgramsModel =  this.getloyaltyProgram().find(
            (res: LoyaltyProgramsModel) =>  {
                return res.name === name
            })!;
        return found;


    }

  static findByCode(code: string): LoyaltyProgramsModel {
    if(this.getloyaltyProgram().length === 0){
      return new LoyaltyProgramsModel();
    }
    const found: LoyaltyProgramsModel =  this.getloyaltyProgram().find(
      (res: LoyaltyProgramsModel) =>  {
        return res.id === code
      })!;
    return found;


  }

    static setloyaltyProgram(loyaltyProgram: LoyaltyProgramsModel[]) {
        this.loyaltyProgram = loyaltyProgram;
    }

    static getloyaltyProgram(): LoyaltyProgramsModel[]{
        return this.loyaltyProgram;
    }
}

export class LoyaltyProgramsModel implements LoyaltyProgramsInt {
    id: string = "";
    name: string = "";
    pattern: string = "";
    patternError: string = "";
    max: number = 0;
    allowAlpha: boolean = false;
    regex?: RegExp;
    constructor (
        layaltyProgram?: LoyaltyProgramsInt
    ) {
        if ( layaltyProgram ) {
            this.id = layaltyProgram.id;
            this.name = layaltyProgram.name;
            this.pattern = layaltyProgram.pattern;
            this.regex = new RegExp(layaltyProgram.pattern);
            this.patternError = layaltyProgram.patternError;
            this.max = layaltyProgram.max;
            this.allowAlpha = layaltyProgram.allowAlpha;
        }
    }

}
